import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drawer_bar = _resolveComponent("drawer-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_content = _resolveComponent("v-content")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_FootersTab = _resolveComponent("FootersTab")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_drawer_bar),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_fade_transition, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FootersTab)
    ]),
    _: 1
  }))
}